module.exports = __webpack_public_path__ + "img/140ne.f21cf5b9.svg";